<template lang="pug">
Page(titleType="custom")
  template(slot="header-left-dropdown")
    PageHeaderTabs.m-left-10(
      :links="pageTabLinks",
      translationGroup="B2B"
    )
  template(slot="overgroups-left")
    ToggleOverGroups(
      :list="IntStoreGroupList",
      :selectedItem="selectedStoreGroup",
      @delegateChangeSelectedItem="onChangeStoreGroup",
      selectedKey="storeGroupId",
      fieldKey="storeGroupName"
    )
  template(slot="content-center")
    TableLoading(v-if="isFetchingSettingInfo")
    SettingsForm(
      v-else,
      :form="form",
      :isLoadingAction="isLoading"
      :onSubmitAction="onSubmitForm"
    )
      template(slot="extraField")

        .Form-item.required
          label.Form-item-label {{ $t('Integration.StoreGroup_FormField_termPeriod') }}
          .control
            customTextInput(
              name="termPeriod"
              :error="veeErrors.has('termPeriod')"
              :data-vv-as="$t('Integration.StoreGroup_FormField_termPeriod')",
              v-validate="'required|max:32'"
              id="input-settings-form-field-termPeriod"
              v-model="form.termPeriod"
              :isDelayInput="true"
            )
            p.Form-item-help.is-danger(
              v-show="veeErrors.has('termPeriod')")
              | {{ veeErrors.first('termPeriod') }}

        .Form-item
          label.Form-item-label {{ $t('Integration.StoreGroup_FormField_databaseName') }}
          .control
            customTextInput(
              name="databaseName"
              :error="veeErrors.has('databaseName')"
              :data-vv-as="$t('Integration.StoreGroup_FormField_databaseName')",
              v-validate="'required|max:128'"
              id="input-settings-form-field-database-name"
              v-model="form.databaseName"
              :isDelayInput="true"
            )
            p.Form-item-help.is-danger(
              v-show="veeErrors.has('databaseName')")
              | {{ veeErrors.first('databaseName') }}

        .checkField
          CustomCheckbox.m-right-25(
            v-model="form.syncApprovedOrders",
            :label="$t('Integration.syncApprovedOrders')"
          )

          CustomCheckbox(
            v-model="form.syncDespatches",
            :label="$t('Integration.syncDespatches')"
          )
</template>

<script>
import ToggleOverGroups from '@/view/global/toggle-over-groups'
import SettingsForm from '@/view/pages/Integration/components/SettingsForm'
import { vueWaitLoader } from '@/utils/baseOperations'
//

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'B2BLOGStoreGroup',
  /**
  **/
  data () {
    return {
      form: {
        companyNumber: null,
        username: null,
        password: null,
        apiAddress: null,
        clientId: null,
        clientSecret: null,
        companyDivision: null,
        syncApprovedOrders: false,
        syncDespatches: false,
        termPeriod: null,
        databaseName: null
      }
    }
  },
  /**
  **/
  components: {
    ToggleOverGroups,
    SettingsForm
  },

  /**
  **/

  computed: {
    ...mapGetters('IntegrationB2bLogo', ['pageTabLinks', 'selectedStoreGroup']),
    ...mapGetters('IntegrationAccountingLogo', ['IntStoreGroupList']),
    ...mapGetters('Settings', ['UserInfo']),

    IntegrationProductId () {
      return this.$route.params.IntegrationProductId
    },

    isFetchingSettingInfo () {
      return this.$wait.is(['getIntegrationStoreGroup', 'configPageLoading'])
    },

    isLoading () {
      return this.$wait.is(['storeGroupConfigB2B'])
    }
  },

  methods: {
    ...mapActions('IntegrationAccountingLogo', [
      'saveIntegrationStoreGroup',
      'getIntegrationStoreGroup',
      'fetchIntStoreGroupList'
    ]),

    ...mapMutations('IntegrationB2bLogo', ['SET_SELECTED_STORE_GROUP']),

    getIntegrationStoreGroupWithParams () {
      const params = {
        StoreGroupId: this.selectedStoreGroup.storeGroupId,
        IntegrationProductId: this.IntegrationProductId
      }
      this.getIntegrationStoreGroup(params)
        .then(res => {
          this.form = res.data.intStoreGroup
          this.$validator.reset()
        })
    },

    ...mapActions('Notify', [
      'notifyShow'
    ]),

    async onChangeStoreGroup (storeGroup) {
      this.SET_SELECTED_STORE_GROUP(storeGroup)
      await this.getIntegrationStoreGroupWithParams()
    },

    onSubmitForm: vueWaitLoader(async function (form) {
      await this.$validator.validate('termPeriod').then(async result => {
        if (!result) return
        let params = {
          ...form,
          isPasswordFilled: !!form.password,
          isClientSecretFilled: !!form.clientSecret,
          storeGroupId: this.selectedStoreGroup.storeGroupId,
          integrationproductId: this.IntegrationProductId
        }
        const res = await this.saveIntegrationStoreGroup(params)
        if (!res) return
        const message = this.$t('Integration.StoreGroupSuccessUpdated')
        this.notifyShow({ message })
        this.getIntegrationStoreGroupWithParams()
      })
    }, 'storeGroupConfigB2B')
  },

  async mounted () {
    this.$wait.start('configPageLoading')
    await this.fetchIntStoreGroupList({
      IntegrationProductId: this.IntegrationProductId
    })
    const defaultStore = this.IntStoreGroupList.find(_ => _.isStoreGroupDefault)
    const selectedStoreGroup = this.selectedStoreGroup.hasOwnProperty('storeGroupId') ? this.selectedStoreGroup : defaultStore
    await this.onChangeStoreGroup(selectedStoreGroup)
    this.$wait.end('configPageLoading')
  }
}
</script>

<style lang="scss">

  .checkField {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: $input-size;
    margin-top: 27.5px; // for label and lineheight
    margin-bottom: 48px;

  }

</style>
